import moment from "moment";

const parseDate = (dateString) => {
    if (dateString === undefined || dateString === null) {
        return null;
    }
    if (dateString.includes('T') && dateString.includes('-') && dateString.includes(':')) {
        return moment.parseZone(dateString);
    } else {
        return moment.utc(dateString, "MM/DD/YYYY HH:mm A");
    }
};

function validateDate(dateString) {
    let date = parseDate(dateString);

    if (date !== null && date.isValid()) {
        return date;
    }

    return "";
}

// get hours from date string
export const getMonth = (dateString) => {
    let date = validateDate(dateString);
    if (date !== null) {
        return date.format("MM/DD/YYYY");
    }

    return "";

};

// get hours from date string
export const getHours = (dateString) => {
    let date = parseDate(dateString);
    if (date !== null && date.isValid()) {
        return date.format("h:mm");
    }
    return "";
};


export const getAMorPM = (dateString) => {
    let date = parseDate(dateString);
    if (date !== null && date.isValid()) {
        return date.format("A").toLowerCase();
    }
    return "";
};

export const getTimeZone = (dateString) => {
    let date = parseDate(dateString);
    if (date !== null && date.isValid()) {
        return date.format("z");
    }
    return "";
};

export const getDateFromDateString = (dateString) => {
    let date = parseDate(dateString);
    if (date !== null) {
        return date.format("MM/DD/YYYY");
    }
    return "";
};

export const getWeekDayFromDateString = (dateString) => {
    let date = parseDate(dateString);
    if (date !== null && date.isValid()) {
        return date.format("dddd");
    }
    return "";
};

const dateEqualsTarget = (dateString, targetDate) => {
    let date = parseDate(dateString);
    if (date !== null && date.isValid()) {
        return date.isSame(targetDate, "day");
    }
    return false;
};

export const dateEqualsToday = (dateString) => {
    return dateEqualsTarget(dateString, moment(new Date()));
};

export const dateEqualsYesterday = (dateString) => {
    return dateEqualsTarget(dateString, moment(new Date()).subtract(1, "days"));
};

export const dateEqualsTomorrow = (dateString) => {
    return dateEqualsTarget(dateString, moment(new Date()).add(1, "days"));
};

export const formatDateString = (dateString, format) => {
    let date = parseDate(dateString);
    if (date !== null) {
        return date.format(format);
    }
    return "";
};

export const sortScanDates = (scanDetails) => {
    if (scanDetails) {
        scanDetails.sort(function (a, b) {
            return (a.scanOffsetTime < b.scanOffsetTime) ? -1 : ((a.scanOffsetTime > b.scanOffsetTime) ? 1 : 0);
        });
    }
};



// WEBPACK FOOTER //
// ./src/shared/dateFormatter.js